module.exports = __webpack_public_path__ + "static/media/ios-battery-full.992ccb8e.svg";